<template>
  <div class="page">
    <c-source-page
      :columns="columns"
      :filter="filter"
      :table="table"
      :pagination="pagination"
      resource="logistics"
    />
  </div>
</template>


<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class Logistics extends Vue {

  table = { data: [] }
  pagination = {}

  filter = [
    {
      prop: 'so_id_cont',
      label: '订单号',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'lc_id_cont',
      label: '公司代码',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'l_id_cont',
      label: '快递单号',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'send_date_gteq_datetime',
      form: {
        component: 'datePicker',
        props: { placeholder: '开始时间' }
      },
    },
    {
      prop: 'send_date_lteq_datetime',
      form: {
        component: 'datePicker',
        props: { placeholder: '结束时间' }
      }
    },
  ]

  get columns() {
    return [
      ...createColumns.call(this),
      {
        prop: 'action',
        label: '操作',
        fixed: 'right',
        width: 100,
        detail: true
      }
    ];
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/logistics', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
